import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon1.png'
import _imports_1 from '@/assets/images/copyIcon.png'


const _withScopeId = n => (_pushScopeId("data-v-6ce372c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "billDetail" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "head" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flexRow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "USDT")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "flexColumn"
}
const _hoisted_6 = { class: "money" }
const _hoisted_7 = {
  key: 1,
  class: "flexColumn"
}
const _hoisted_8 = {
  key: 0,
  class: "money"
}
const _hoisted_9 = {
  key: 1,
  class: "money"
}
const _hoisted_10 = {
  key: 2,
  class: "money"
}
const _hoisted_11 = { class: "titleInfo" }
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = { class: "left" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = {
  key: 1,
  class: "row"
}
const _hoisted_16 = { class: "left" }
const _hoisted_17 = { class: "content" }
const _hoisted_18 = {
  key: 2,
  class: "row"
}
const _hoisted_19 = { class: "left" }
const _hoisted_20 = { class: "content" }
const _hoisted_21 = {
  key: 3,
  class: "row"
}
const _hoisted_22 = { class: "left" }
const _hoisted_23 = { class: "content" }
const _hoisted_24 = {
  key: 4,
  class: "row"
}
const _hoisted_25 = { class: "left" }
const _hoisted_26 = { class: "content" }
const _hoisted_27 = {
  key: 5,
  class: "row"
}
const _hoisted_28 = { class: "left" }
const _hoisted_29 = { class: "content" }
const _hoisted_30 = {
  key: 6,
  class: "row"
}
const _hoisted_31 = { class: "left" }
const _hoisted_32 = { class: "content" }
const _hoisted_33 = {
  key: 7,
  class: "row"
}
const _hoisted_34 = { class: "left" }
const _hoisted_35 = { class: "content" }
const _hoisted_36 = {
  key: 8,
  class: "row"
}
const _hoisted_37 = { class: "left" }
const _hoisted_38 = { class: "content" }
const _hoisted_39 = {
  key: 9,
  class: "row"
}
const _hoisted_40 = { class: "left" }
const _hoisted_41 = { class: "content" }
const _hoisted_42 = {
  key: 10,
  class: "row"
}
const _hoisted_43 = { class: "left" }
const _hoisted_44 = { class: "content" }
const _hoisted_45 = {
  key: 11,
  class: "row"
}
const _hoisted_46 = { class: "left" }
const _hoisted_47 = { class: "content" }
const _hoisted_48 = {
  key: 12,
  class: "row"
}
const _hoisted_49 = { class: "left" }
const _hoisted_50 = { class: "content" }
const _hoisted_51 = {
  key: 13,
  class: "row"
}
const _hoisted_52 = { class: "left" }
const _hoisted_53 = { class: "content" }
const _hoisted_54 = {
  key: 14,
  class: "row"
}
const _hoisted_55 = { class: "left" }
const _hoisted_56 = { class: "content" }
const _hoisted_57 = {
  key: 15,
  class: "row"
}
const _hoisted_58 = { class: "left" }
const _hoisted_59 = { class: "content" }
const _hoisted_60 = {
  key: 16,
  class: "row"
}
const _hoisted_61 = { class: "left" }
const _hoisted_62 = { class: "content" }
const _hoisted_63 = {
  key: 17,
  class: "row"
}
const _hoisted_64 = { class: "left" }
const _hoisted_65 = { class: "content" }
const _hoisted_66 = {
  key: 18,
  class: "row"
}
const _hoisted_67 = { class: "left" }
const _hoisted_68 = { class: "content" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "left" }
const _hoisted_71 = { class: "content" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "left" }
const _hoisted_74 = { class: "content" }
const _hoisted_75 = {
  key: 19,
  class: "row"
}
const _hoisted_76 = { class: "left" }
const _hoisted_77 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.langObj.l0071), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_ctx.data.type == 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.data.mode == 1 ? "+" : "-") + _toDisplayString(Number(Math.abs(_ctx.data.currentAmount - _ctx.data.previousAmount))
                            .toFixed(6)
                            .toString()), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.data.amount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.data.mode == 1 ? "+" : "-") + " " + _toDisplayString(_ctx.data.amount &&
                            Number(_ctx.data.amount)
                                .toFixed(6)
                                .toString()), 1))
              : _createCommentVNode("", true),
            (_ctx.data.fromCode && _ctx.data.toAmount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.data.mode == 1 ? "+" : "-") + " " + _toDisplayString(_ctx.data.toAmount &&
                            Number(_ctx.data.toAmount)
                                .toFixed(6)
                                .toString()), 1))
              : _createCommentVNode("", true),
            (_ctx.data.usdtAmount && _ctx.data.usdtAmount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.data.mode == 1 ? "+" : "-") + " " + _toDisplayString(_ctx.data.usdtAmount &&
                            Number(_ctx.data.usdtAmount)
                                .toFixed(6)
                                .toString()), 1))
              : _createCommentVNode("", true)
          ])),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.getSubTitle()), 1)
    ]),
    (_ctx.data.orderNo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.langObj.l0072), 1),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.data.orderNo), 1),
          _createElementVNode("img", {
            src: _imports_1,
            class: "icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyAction(_ctx.data.orderNo)))
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.orderNO)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.langObj.l0072), 1),
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.data.orderNO), 1),
          _createElementVNode("img", {
            src: _imports_1,
            class: "icon",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyAction(_ctx.data.orderNO)))
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.orderId > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.langObj.l0072), 1),
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.data.orderId), 1),
          _createElementVNode("img", {
            src: _imports_1,
            class: "icon",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyAction(_ctx.data.orderId)))
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.otherUserName && _ctx.data.type != 7)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.langObj.l0073), 1),
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.data.otherUserName), 1)
        ]))
      : _createCommentVNode("", true),
    ((_ctx.data.payUserId > 0 || _ctx.data.receiveUserId > 0) && _ctx.data.type == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.langObj.l0074) + "Id", 1),
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.user.userId == _ctx.data.payUserId ? _ctx.data.receiveUserId.toString() : _ctx.data.payUserId.toString()), 1),
          _createElementVNode("img", {
            src: _imports_1,
            class: "icon",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyAction(_ctx.user.userId == _ctx.data.payUserId ? _ctx.data.receiveUserId.toString() : _ctx.data.payUserId.toString())))
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.merchant)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.langObj.l0080), 1),
          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.data.merchant), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.addr && _ctx.data.type != 6 && _ctx.data.type != 7)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.langObj.l0073), 1),
          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.data.addr && _ctx.data.addr.toString()), 1),
          _createElementVNode("img", {
            src: _imports_1,
            class: "icon",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyAction(_ctx.data.addr.toString())))
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.withdrawService)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.langObj.l0075), 1),
          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.data.withdrawService &&
                        Number(_ctx.data.withdrawService)
                            .toFixed(6)
                            .toString()) + "USDT ", 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.type == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.langObj.l0076), 1),
          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.data.incomeAmount &&
                        Number(_ctx.data.incomeAmount)
                            .toFixed(6)
                            .toString()) + "USDT ", 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.digital_from)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.langObj.l0073), 1),
          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.data.digital_from && _ctx.data.digital_from.toString()), 1),
          _createElementVNode("img", {
            src: _imports_1,
            class: "icon",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copyAction(_ctx.data.digital_from.toString())))
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.nickname)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.langObj.l0077), 1),
          _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.data.nickname), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.merchantName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.langObj.l0077), 1),
          _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.data.merchantName), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.merchantNo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.langObj.l0078), 1),
          _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.data.merchantNo && _ctx.data.merchantNo.toString()), 1),
          _createElementVNode("img", {
            src: _imports_1,
            class: "icon",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.copyAction(_ctx.data.merchantNo && _ctx.data.merchantNo.toString())))
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.transferRate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.langObj.l0079), 1),
          _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.data.transferRate && _ctx.data.transferRate.toString()), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.merchant)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.langObj.l0080), 1),
          _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.data.merchant), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.fromCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.langObj.l0081), 1),
          _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.data.fromCode), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.fromCode && _ctx.data.amount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.langObj.l0082), 1),
          _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.data.amount), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.toCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.langObj.l0083), 1),
          _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.data.toCode), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.rate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.langObj.l0084), 1),
          _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.data.rate), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_69, [
      _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.langObj.l0085), 1),
      _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.getTime(_ctx.data.createTime)), 1)
    ]),
    _createElementVNode("div", _hoisted_72, [
      _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.langObj.l0086), 1),
      _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.getCategory()), 1)
    ]),
    (_ctx.data.remarks && _ctx.data.remarks.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.langObj.l0036), 1),
          _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.data.remarks), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}